import { render, staticRenderFns } from "./NewContent.vue?vue&type=template&id=6fd7065a"
import script from "./NewContent.vue?vue&type=script&lang=js"
export * from "./NewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports